import React from 'react';
import { __ } from 'locale';

const cls = 'w-[calc(100%-76px)] my-4 ml-[70px] max-[959px]:my-3 max-[959px]:ml-10 rounded-xl border border-amber-200 border-l-4 border-l-amber-400 bg-amber-50 shadow-sm overflow-hidden cursor-default text-sm';

function TrainingItem({ training }) {
    let sh = training.startHour < 10 ? '0' + training.startHour : training.startHour;
    let sm = training.startMinute < 10 ? '0' + training.startMinute : training.startMinute;

    return (
        <div className={cls}>
            <div className="flex flex-wrap items-center py-3 px-4 text-amber-900">
                <p className="m-0 flex items-center gap-2">
                    <i className="fa fa-clock text-amber-500 text-xs"></i>
                    <span className="text-amber-600 font-mono text-xs">{sh}:{sm}</span>
                    <span className="text-amber-300">&mdash;</span>
                    <b className="uppercase tracking-wide text-sm">{__('Trénink')}</b>
                </p>
                <aside className="ml-auto text-right">
                    <b className="font-semibold text-amber-900">{training.description}</b>
                    <span className="text-amber-600 text-xs ml-2">{__('Délka')}: {training.length} {__('minut')}</span>
                </aside>
            </div>
        </div>
    );
}

export default TrainingItem;
